export default "/images/vendor/flag-icons/flags/4x3/ck.svg?6f73c68e1aca3060e929c43108bb8a3f";